import {
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Upload,
  Space
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import {
  API_IMG_UPLOAD
} from "../../../../constants";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import PlusCircleOutlined from "@ant-design/icons/lib/icons/PlusCircleOutlined";
import MinusCircleOutlined from "@ant-design/icons/lib/icons/MinusCircleOutlined";
import React, {useEffect, useRef, useState} from 'react'
import {getCategorieList, getProductSave} from "../../../../constants/api";
import {removeToken} from "../../../../utils/cookie";
import ImgCrop from 'antd-img-crop';

import {COMMON_ROUTER} from "../../../../constants";

const FormItem = Form.Item
const Option = Select.Option;
const formItemLayout = {
  labelCol: {
    xs: {span: 24},
    sm: {span: 8},
  },
  wrapperCol: {
    xs: {span: 24},
    sm: {span: 16},
  },
}
//根据官方属性定制化裁剪框大小固定的裁剪组件属性
const props = {
  width: 800,  //裁剪宽度
  height: 800, //裁剪高度
  rotate: true,
  zoom: true,
  resize: true, //裁剪是否可以调整大小
  resizeAndDrag: true, //裁剪是否可以调整大小、可拖动
  modalTitle: "上传图片", //弹窗标题
  modalWidth: 900, //弹窗宽度
};

const useComponentWillMount = func => {
  const willMount = useRef(true);

  if (willMount.current) {
    func();
  }

  willMount.current = false;
};

const AddFlowerGoods = ({location, history}) => {
  const [fileList, setFileList] = useState([])
  const [fileListSecond, setFileListSecond] = useState([])
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState([])
  const [isPutAway, setIsPutAway] = useState(1)
  const [xmCategory, setXmCategory] = useState([])
  const [xmCategoryId, setXmCategoryId] = useState(0)

  const storage = window.localStorage;
  const [shopIdStorage, setShopIdStorage] = useState(0)
  const [categoryIdStorage, setCategoryIdStorage] = useState(0)

  useEffect(() => {
    getCategory()
  }, [])
  //获取店铺品类
  const getCategory = () => {
    let shopIdValue = 0;
    let categoryIdValue = 0;
    if (location.state) {
      shopIdValue = location.state.shopId
      storage.setItem('SKIP_SHOPID', shopIdValue);

      categoryIdValue = location.state.tempCategoryId
      storage.setItem('SKIP_CATEGORYID', categoryIdValue);
    } else {
      shopIdValue = storage.getItem('SKIP_SHOPID')
      categoryIdValue = storage.getItem('SKIP_CATEGORYID')
    }
    setShopIdStorage(shopIdValue)
    setCategoryIdStorage(categoryIdValue)

    getCategorieList({
      pageIndex: 0,
      pageSize: 100,
      sortName: "",
      sortType: "",
      id: shopIdValue
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          if (data.data == null) {
            setXmCategory([])
          } else {
            if (data.data.records == null || data.data.records.length == 0) {
              setXmCategory([])
            } else {
              setXmCategory(data.data.records)
            }
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  //base64图片文件
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  //图片预览取消函数
  const handleCancel = () => setPreviewVisible(false);
  //图片预览弹窗函数
  const handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewVisible(true);
    setPreviewImage(file.url || file.preview)
  };
  const beforeUpload = (file) => {
    //限制图片 格式、size、分辨率
    const isJPG = file.type === 'image/jpeg';
    const isJPEG = file.type === 'image/jpeg';
    const isGIF = file.type === 'image/gif';
    const isPNG = file.type === 'image/png';
    if (!(isJPG || isJPEG || isGIF || isPNG)) {
      Modal.error({
        title: '只能上传JPG 、JPEG 、GIF、 PNG格式的图片~',
      });
      return;
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      Modal.error({
        title: '超过5M限制，不允许上传~',
      });
      return;
    }
    return (isJPG || isJPEG || isGIF || isPNG) && isLt2M && checkImageWH(file);
  }

  //返回一个 promise：检测通过则返回resolve；失败则返回reject，并阻止图片上传
  const checkImageWH = (file) => {
    return new Promise(function (resolve, reject) {
      let filereader = new FileReader();
      filereader.onload = e => {
        let src = e.target.result;
        const image = new Image();
        image.onload = function () {
          // 获取图片的宽高，并存放到file对象中
          file.width = this.width;
          file.height = this.height;
          resolve();
        };
        image.onerror = reject;
        image.src = src;
      };
      filereader.readAsDataURL(file);
    });
  }

  //上传文件改变时的状态，详情可以参考antd的Upload组件API参数
  const onImgChange = ({fileList}) => {
    // console.log(fileList)
    setFileList(fileList)
  };

  const onImgChangeSecond = ({fileList}) => {
    // console.log('img+++')
    // console.log(fileList)
    setFileListSecond(fileList)
  };

  //选择分类
  const changexmCategoryId = (value) => {
    setXmCategoryId(value)
  }

  //请求添加商品
  const onFinish = (values) => {
    //商品名称
    let productName = values.productName
    //顺序号
    let shelfNumber = values.shelfNumber ? values.shelfNumber: ''
    //商品描述
    let description = values.description ? values.description : ''
    //备注
    let remark = values.remark ? values.remark : ''

    if (fileListSecond.length < 0) {
      message.error('请添加商品图片', 1)
      return
    }
    //图
    let images = []
    // console.log(fileListSecond)
    fileListSecond.map((item, index) => {
      let resp = item.response
      if (resp.code === 0) {
        let imgs = resp.data
        let im = {
          imageUrl: imgs.imageSite + imgs.imagePath
        }
        images.push(im)
      }
    })

    let imageUrlMain = ''
    let imagesSecond = []
    images.map((item,index)=>{
      if (index === 0) {
        imageUrlMain = item.imageUrl
      } else {
        imagesSecond.push(item)
      }
    })
    // console.log('***')
    // console.log(imageUrlMain)

    //属性
    let productSku = values.productSku ? values.productSku : ''
    // console.log(productSku)
    let sku = []
    if (productSku == '') {
    } else {
      if (productSku.indexOf(",") != -1) {
        sku = productSku.split(",")
      } else if (productSku.indexOf("，") != -1) {
        sku = productSku.split("，")
      }
    }

    //价格
    let price = values.productPrice
    //库存
    let stock = values.productStore ? values.productStore: ''
    if (stock < 0 || stock > 99999) {
      message.error('库存范围为0~99999', 1,)
      return;
    }
    //是否上架
    let onShelf = values.isPutAway

    //售卖属性
    let attribute = values.attribute;
    let attributeTemp = []
    attribute && attribute.map((item, index) => {
      let details = [];
      let attributeName = item.attributeName;
      if (item.detail_one) {
        details.push(item.detail_one)
      }
      if (item.detail_two) {
        details.push(item.detail_two)
      }
      if (item.detail_three) {
        details.push(item.detail_three)
      }
      if (item.detail_four) {
        details.push(item.detail_four)
      }

      let attr = {};
      attr['name'] = attributeName;
      attr['children'] = details
      attributeTemp.push(attr)
    })
    let attributeTempStr = JSON.stringify(attributeTemp)
    // console.log('+++++++++++++++++++++++++++++++++++')
    // console.log(attributeTemp)
    // console.log(attributeTempStr)

    getProductSave({
      categoryId: xmCategoryId,
      dataStatus: onShelf,
      description: description,
      imagePath: imageUrlMain,
      // otherSku: sku,
      otherSku: attributeTempStr,
      price: price,
      productId: 0,
      productName: productName,
      remark: remark,
      shopId: shopIdStorage,
      sortNum: shelfNumber,
      stock: stock
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          message.success('添加成功', 1, () => {
            history.push({
                  pathname: COMMON_ROUTER + '/goods',
                  state: {
                    tempCategoryId: categoryIdStorage
                  }
                }
            )
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }
  const toBack = () => {
    history.push({
      pathname: COMMON_ROUTER + "/goods",
      state: {
        tempCategoryId: categoryIdStorage
      }
    })
  }

  //改变商品是否上架的状态
  const onChangeHot = (e) => {
    // console.log(e)
    setIsPutAway(e.target.value)
  }
  let fetchedFields1 = [{'name': 0, 'key': 0, 'fieldKey': 0}, {'name': 1, 'key': 1, 'fieldKey': 1}];
  let fetchedFields2 = [{'name': 0, 'key': 0, 'fieldKey': 0}];

  return (
    <Form onFinish={onFinish} initialValues={{isPutAway: isPutAway, attribute: fetchedFields1, materialList: fetchedFields2}}>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'top'}>
        <Col className={['gutter-row']} offset={6} span={2}>
          <div className='input-title'>基本信息</div>
        </Col>
      </Row>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name='xmCategoryId' label="品类"
                    rules={[{required: true, message: '请选择品类',}]} {...formItemLayout}>
            <Select
              showSearch
              listItemHeight={10}
              listHeight={250}
              value={xmCategoryId}
              style={{marginLeft: '20px'}}
              bordered={true}
              placeholder={'请选择品类'}
              onChange={changexmCategoryId}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {xmCategory && xmCategory.map((item) => {
                return <Option key={item.categoryId} value={item.categoryId}>{item.categoryName}</Option>
              })}
            </Select>
          </FormItem>
        </Col>
      </Row>
      {/*<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">*/}
      {/*  <Col className='gutter-row' offset={6} span={10} id={'materialList'}>*/}
      {/*    <FormItem name='materialList' label="商品类目"*/}
      {/*              rules={[{required: true, message: '请选择商品类目',}]} {...formItemLayout}>*/}
      {/*      <Cascader*/}
      {/*        allowClear*/}
      {/*        value={materialNames}*/}
      {/*        fieldNames={{label: 'materialName', value: 'id',}}*/}
      {/*        style={{marginLeft: '20px'}}*/}
      {/*        options={material}*/}
      {/*        loadData={(selectedOptions) => loadData(material, selectedOptions)}*/}
      {/*        onChange={onMaterialChange}*/}
      {/*        changeOnSelect*/}
      {/*        getPopupContainer={() => document.getElementById('materialList')}*/}
      {/*        placeholder={'请选择'}*/}
      {/*      />*/}
      {/*    </FormItem>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name='productName' label="商品名称"
                    rules={[{required: true, message: '请输入商品名称',}]} {...formItemLayout}>
            <Input style={{marginLeft: "20px"}} maxLength = {50} placeholder="请输入商品名称"/>
          </FormItem>
        </Col>
      </Row>
      {/*<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">*/}
      {/*  <Col className='gutter-row' offset={6} span={10}>*/}
      {/*    <FormItem name='shelfNumber' label="顺序"*/}
      {/*              {...formItemLayout}>*/}
      {/*      <Input style={{marginLeft: "20px"}} placeholder="请输入顺序号"/>*/}
      {/*    </FormItem>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name='description' label="商品描述" {...formItemLayout}>
            <TextArea style={{marginLeft: "20px"}} maxLength = {250} placeholder={'请输入商品描述'} rows={4}/>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name='remark' label="备注" {...formItemLayout}>
            <TextArea style={{marginLeft: "20px"}} maxLength = {250} placeholder={'请输入备注'} rows={4}/>
          </FormItem>
        </Col>
      </Row>
      {/*<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">*/}
      {/*  <Col className='gutter-row' offset={6} span={10}>*/}
      {/*    <FormItem name='productCode' label="条形码"*/}
      {/*              rules={[{required: true, message: '请输入商品条形码',}]} {...formItemLayout}>*/}
      {/*      <Input style={{marginLeft: "20px"}} placeholder="请输入商品条形码"/>*/}
      {/*    </FormItem>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      {/*<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">*/}
      {/*  <Col className='gutter-row' offset={6} span={10}>*/}
      {/*    <FormItem label="商品主图" rules={[{required: true, message: '请添加商品主图',}]} labelCol={{span: 4}}*/}
      {/*              {...formItemLayout}>*/}
      {/*      <Upload*/}
      {/*        name="file"*/}
      {/*        action={API_IMG_UPLOAD}*/}
      {/*        data={{platformType: location.state.platformType}}*/}
      {/*        accept="image/*"*/}
      {/*        listType="picture"*/}
      {/*        fileList={fileList}*/}
      {/*        beforeUpload={beforeUpload}*/}
      {/*        onPreview={handlePreview}*/}
      {/*        onChange={onImgChange}*/}
      {/*      >*/}
      {/*        {fileList && fileList.length >= 1 ? null : (<div className='img-container'>*/}
      {/*          <div>*/}
      {/*            <PlusOutlined style={{fontSize: "20px"}}/>*/}
      {/*            点击上传*/}
      {/*          </div>*/}
      {/*        </div>)}*/}
      {/*      </Upload>*/}

      {/*      <Modal visible={previewVisible} footer={null} onCancel={handleCancel} title='Image-Show'>*/}
      {/*        <img alt="example" style={{width: '100%'}} src={previewImage}/>*/}
      {/*      </Modal>*/}
      {/*    </FormItem>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem label="商品图片" rules={[{required: true, message: '请添加商品图片',}]} labelCol={{span: 4}}
                    {...formItemLayout}>
            {/*<ImgCrop {...props}>*/}
            <Upload
              name="file"
              action={API_IMG_UPLOAD}
              data={{fileType: 2}}
              accept="image/*"
              listType="picture-card"
              fileList={fileListSecond}
              beforeUpload={beforeUpload}
              onPreview={handlePreview}
              onChange={onImgChangeSecond}
            >
              {fileListSecond && fileListSecond.length >= 1 ? null : (<div className='img-container' style={{marginLeft: 3}}>
                <div>
                  <PlusOutlined style={{fontSize: "20px"}}/>
                  点击上传
                </div>
              </div>)}
            </Upload>
            {/*</ImgCrop>*/}

            <Modal visible={previewVisible} footer={null} onCancel={handleCancel} title='Image-Show'>
              <img alt="example" style={{width: '100%'}} src={previewImage}/>
            </Modal>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={20}>
          <Divider/>
        </Col>
      </Row>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align="top">
        <Col className={['gutter-row',]} offset={6} span={2}>
          <div className='input-title'>售卖规格</div>
        </Col>
        <Col className='gutter-row' span={12}>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' span={10}>
              <FormItem name='productPrice' label="价格"
                        rules={[{required: true, message: '请输入商品售价',}]} {...formItemLayout}>
                <Input style={{marginLeft: "20px"}} placeholder="请输入商品售价"/>
              </FormItem>
            </Col>
          </Row>
          {/*<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">*/}
          {/*  <Col className='gutter-row' span={10}>*/}
          {/*    <FormItem name='productWeight' label="重量"*/}
          {/*              {...formItemLayout}>*/}
          {/*      <Input style={{marginLeft: "20px"}} placeholder="请输入商品重量"/>*/}
          {/*    </FormItem>*/}
          {/*  </Col>*/}
          {/*</Row>*/}

          {/*<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">*/}
          {/*  <Col className='gutter-row' span={10}>*/}
          {/*    <FormItem name='productSku' label="商品属性"*/}
          {/*              {...formItemLayout}>*/}
          {/*      <Input style={{marginLeft: "20px"}} placeholder="微辣，中辣，特辣"/>*/}
          {/*    </FormItem>*/}
          {/*  </Col>*/}
          {/*  <Col className='gutter-row' span={10} style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: 30}}>*/}
          {/*    <span style={{color: '#ff0000', fontSize: 10}}>注：各个属性中间用‘，’号分隔;如 ”微辣，中辣，特辣“</span>*/}
          {/*  </Col>*/}
          {/*</Row>*/}

          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' span={10}>
              <FormItem name='productStore' label="商品库存"
                        rules={[
                          {required: true, message: '请输入商品库存'},
                          {
                            validator(rule, values, callback) {
                              console.log('----------------')
                              console.log(values)
                              if (values <= 0 && values >= 99999) {
                                callback('库存范围在0~99999')
                              } else {
                                callback()
                              }
                            }
                          }]} {...formItemLayout}>
                <Input style={{marginLeft: "20px"}} placeholder="请输入商品库存"/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={1} span={10}>
              <Form.Item label="是否上架" name='isPutAway'>
                <Radio.Group onChange={onChangeHot}>
                  <Radio value={1}>是</Radio>
                  <Radio value={0}>否</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'top'}>
        <Col className={['gutter-row',]} offset={6} span={2}>
          <div className='input-title'>售卖属性</div>
        </Col>
        <Col className='gutter-row' id='materialList' span={10}>
          <Form.List name="attribute">
            {(fields, {add, remove}) => {
              return (
                  <div>
                    {fields.map((field, index) => (
                        <Space key={field.key} style={{display: 'flex', marginBottom: 8}}>
                          <div key={index.toString()}>
                            <div>
                              同种价格多种口味，如：少糖、半糖等 &nbsp;&nbsp;
                              {/*<a>了解详情</a>*/}
                            </div>
                            <div className='input-specification'>
                              <FormItem
                                  name={[field.name, 'attributeName']} label="属性名称" layout="vercital">
                                <Input className='input-size' placeholder='如:辣度'/>
                              </FormItem>
                              <FormItem rules={[
                                {
                                  required: true,
                                }
                              ]} label="属性细分(至少填2个)" layout="vercital">
                                <Input.Group compact>
                                  <FormItem name={[field.name, 'detail_one']} wrapperCol={{span: 12}} layout="vercital">
                                    <Input className='input-size'/>
                                  </FormItem>
                                  <FormItem name={[field.name, 'detail_two']} wrapperCol={{span: 12}} layout="vercital">
                                    <Input className='input-size'/>
                                  </FormItem>
                                  <FormItem name={[field.name, 'detail_three']} wrapperCol={{span: 12}}
                                            layout="vercital">
                                    <Input className='input-size'/>
                                  </FormItem>
                                  <FormItem name={[field.name, 'detail_four']} wrapperCol={{span: 12}}
                                            layout="vercital">
                                    <Input className='input-size'/>
                                  </FormItem>
                                </Input.Group>
                              </FormItem>
                            </div>
                          </div>
                          {fields.length > 0 ? (
                              <MinusCircleOutlined
                                  className="dynamic-delete-button"
                                  style={{margin: '0 8px'}}
                                  onClick={() => {
                                    remove(field.name);
                                  }}
                              />
                          ) : null}

                        </Space>
                    ))}

                    <Form.Item>
                      <a
                          type="dashed"
                          onClick={() => {
                            add();
                          }}
                      >
                        <PlusCircleOutlined/> 添加属性最多5个
                      </a>
                    </Form.Item>
                  </div>
              );
            }}
          </Form.List>
        </Col>
      </Row>

      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'middle'} justify={'center'}>
        <FormItem>
          <Button onClick={toBack}>返回</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" className="login-form-button">确认</Button>
        </FormItem>
      </Row>
    </Form>
  )
}

export default (props) => {
  return (
    <Card style={{width: '100%', overflowY: "auto", height: "100vh", padding: "0 0 60px"}}>
      <AddFlowerGoods location={props.location} history={props.history}/>
    </Card>
  )
}



// WEBPACK FOOTER //
// ./src/pages/flower/goods/add-goods/index.jsx